import React from 'react';
import { useRouter } from 'next/router';
import { Button, makeStyles } from '@material-ui/core';

import OnlyFansIcon from 'public/icons/network/white/onlyfans.svg';

const useStyles = makeStyles({
  root: {
    height: 40,
    backgroundColor: '#00ADEF',
    color: '#fff',
    marginLeft: 10,
    padding: '6px 24px',

    '&:hover': {
      backgroundColor: 'rgba(0, 173, 239, 0.8)',
    },
  },
});

const OnlyFansC4ConnectionsBtn = () => {
  const router = useRouter();
  const classes = useStyles();

  return (
    <Button
      startIcon={<OnlyFansIcon width={18} height={18} />}
      classes={{ root: classes.root }}
      onClick={() => router.push('/of-connections')}
    >
      Connections
    </Button>
  );
};
export default OnlyFansC4ConnectionsBtn;
